import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {jobStatStatusLabelMap} from '../../../interface/job-stat-menu.interface';
import {WidgetData} from '../../../../../core/shared/widget/widget-data';
import {FilterCriteria} from '../../../../../core/shared/filter/api/filter.criteria';
import {WidgetFactory} from '../../../../../core/shared/widget/service/widget.factory';
import {ObjectRequestList} from '../../../../../core/shared/dto/object/request/object-request-list';
import {ObjectIdentifierData} from '../../../../../core/shared/basic/object-identifier-data';
import {ObjectIdentifier} from '../../../../../core/shared/basic/object-identifier';

@Component({
    selector: 'mvs-jb-job-batch-stats',
    templateUrl: './jb-job-batch-stats.component.html',
    standalone: false
})
export class JbJobBatchStatsComponent implements OnInit {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    jobStatusStatWidget: WidgetData;
    selectedInstance: number;

    constructor(private route: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    refreshComponent() {
        this.route.paramMap.subscribe(params => {
            const status = params.get('status');

            const statusMap: { [key: string]: number } = {
                'Started': 0,
                'Completed': 1,
                'Failed': 2
            };

            const statusId = statusMap[status] ?? null; // Use null or any default if not matched;

            this.refreshReportWidget(statusId, status);
        });
        this.initialized = true;
    }

    refreshReportWidget(statusId: number, statusName: string) {

        // Step 2: Build filter criteria
        let filterCriteria: FilterCriteria[] = [];

        if (statusId !== null) {
            filterCriteria = [FilterCriteria.create('status', FilterCriteria.cOperatorEqual, statusId)];
        }

        this.jobStatusStatWidget = WidgetFactory.createWidget(
            'jb.job.batch.stat.report.table.widget',
            jobStatStatusLabelMap[statusName],
            'table',
            'list',
            'report',
            'jb.run.2'
        );

        this.jobStatusStatWidget.dataProviderListRequest = ObjectRequestList.createBasic(true, filterCriteria, []);
    }

    handleObjectSelect(object: ObjectIdentifierData | ObjectIdentifier) {
        this.selectedInstance = object.objectId;
    }

}
